var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.579,
    height: 21.579,
    viewBox: "0 0 21.579 21.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42.375 -165.68)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.288,165.68H44.848a2.471,2.471,0,0,0-2.473,2.473v13.936a2.471,2.471,0,0,0,2.473,2.473h6.069v-5.44a.807.807,0,0,1,.025-.216c.1-.756.678-1.688,2.642-2.292a14.322,14.322,0,0,1,3.178-.541v-7.92A2.471,2.471,0,0,0,54.288,165.68ZM53.164,174.9a.674.674,0,0,1-1.151.477l-.71-.71-1.278,1.178a.673.673,0,0,1-.792.09l-1.126-.644-1.885,1.884a.674.674,0,1,1-.953-.954l2.247-2.248a.672.672,0,0,1,.811-.109l1.144.655.875-.808-.583-.583a.674.674,0,0,1,.477-1.151H52.49a.675.675,0,0,1,.674.675V174.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 5.844,
    cy: 1.798,
    rx: 5.844,
    ry: 1.798,
    transform: "translate(52.265 177.369)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M282.212,535.2c3.228,0,5.844-.8,5.844-1.8v-1.139c-1.84,1.063-5.006,1.139-5.844,1.139s-4-.077-5.844-1.139V533.4C276.368,534.4,278.984,535.2,282.212,535.2Z",
    transform: "translate(-224.103 -351.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M282.212,607.854c-.838,0-4-.077-5.844-1.139v1.139c0,.994,2.616,1.8,5.844,1.8s5.844-.8,5.844-1.8v-1.139C286.217,607.777,283.05,607.854,282.212,607.854Z",
    transform: "translate(-224.103 -422.394)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.0c44756f2b3040f38c40e0804da32b33.svg";
export { ForwardRef as ReactComponent };